// Persisted Trades view mode (grouped-by-session vs. flat "Refined" grid) so a
// user's explicit Ungroup/Group choice survives navigating away and back to the
// page. Stored in localStorage; absent until the user toggles, so the page can
// fall back to its date-filter-aware default on first visit.

const KEY = "trades:viewMode";

export type TradesViewMode = "grouped" | "flat";

export function readTradesViewMode(): TradesViewMode | null {
  try {
    const value = window.localStorage.getItem(KEY);
    return value === "grouped" || value === "flat" ? value : null;
  } catch {
    return null;
  }
}

export function writeTradesViewMode(mode: TradesViewMode): void {
  try {
    window.localStorage.setItem(KEY, mode);
  } catch {
    // Non-fatal: a private-mode / quota error just means the choice isn't
    // remembered across navigations.
  }
}
